export default __webpack_public_path__ + "static/media/Frame 6970.0387fd35.png";